import { render } from "./CardsHome.vue?vue&type=template&id=6675b980&scoped=true"
import script from "./CardsHome.vue?vue&type=script&lang=js"
export * from "./CardsHome.vue?vue&type=script&lang=js"

import "./CardsHome.vue?vue&type=style&index=0&id=6675b980&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6675b980"]])

export default __exports__